export { default } from './Home24HeroAgo26';
